<template>
  <div>
    <b-breadcrumb
      :items="breadcrumb"
      style="margin-bottom: 0px;"
    ></b-breadcrumb>
    <b-row class="mx-0">
      <b-col cols="3" class="d-none">        
        <div class="filterOptions" style="padding-top:3rem;">
          <div class="tagList">
          <b-badge class="m-1 p-2" v-for="filterCategory in filters.category" :key="'c-'+filterCategory">
            {{categoryName(filterCategory)}}
            <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removeCategory(filterCategory)">&times;</div>
          </b-badge>
          <b-badge class="m-1 p-2" v-for="filterAuthor in filters.author" :key="'a-'+filterAuthor">
            {{authorName(filterAuthor)}}
            <div class="d-inline-block ml-2" style="cursor: pointer;" @click="removeAuthor(filterAuthor)">&times;</div>
          </b-badge>
        </div>
          <div class="filterCategoryTitle">
            <a
              v-b-toggle
              href="#tematica-collapse"
              @click.prevent
              class="d-flex justify-content-between w-100"
            >
              Temática
              <div>
                <b-icon icon="chevron-down" />
                <b-icon icon="chevron-up" />
              </div>
            </a>
          </div>
          <b-collapse id="tematica-collapse">
            <b-list-group flush>
              <template v-for="category in categories">
                <b-list-group-item
                  href="#"
                  v-if="category.childs.length === 0"
                  class="d-flex justify-content-between w-100"
                  :key="category.id"
                  @click="selCategory(category.id)"
                >
                  {{ category.name }}
                </b-list-group-item>
                <b-list-group-item href="#" v-else :key="category.id">
                  <div class="filterCategoryTitleChild">
                    <a
                      v-b-toggle
                      :href="'#tematica-' + category.id + '-collapse'"
                      @click.prevent
                      class="d-flex justify-content-between w-100"
                    >
                      <div @click.prevent="selCategory(category.id)">{{ category.name }}</div>
                      <div>
                        <b-icon icon="chevron-down" />
                        <b-icon icon="chevron-up" />
                      </div>
                    </a>
                  </div>
                  <b-collapse :id="'tematica-' + category.id + '-collapse'">
                    <b-list-group flush>
                      <b-list-group-item
                        v-for="categoryChild in category.childs"
                        href="#"
                        class="d-flex justify-content-between w-100"
                        :key="categoryChild.id"
                        @click="selCategory(categoryChild.id)"
                      >
                        {{ categoryChild.name }}
                      </b-list-group-item>
                    </b-list-group>
                  </b-collapse>
                </b-list-group-item>
              </template>
              <!--<b-list-group-item href="#">Categoría 1</b-list-group-item>
              <b-list-group-item href="#">Categoría 2</b-list-group-item>
              <b-list-group-item href="#">Categoría 3</b-list-group-item>-->
            </b-list-group>
          </b-collapse>

          <div class="filterCategoryTitle">
            <a
              v-b-toggle
              href="#date-collapse"
              @click.prevent
              class="d-flex justify-content-between w-100"
            >
              Fecha
              <div>
                <b-icon icon="chevron-down" />
                <b-icon icon="chevron-up" />
              </div>
            </a>
          </div>
          <b-collapse id="date-collapse">
            <b-list-group flush>
              <b-list-group-item href="#">
                <div class="filterCategoryTitle">
                  <a
                    v-b-toggle
                    href="#year-collapse"
                    @click.prevent
                    class="d-flex justify-content-between w-100"
                  >
                    Año
                    <div>
                      <b-icon icon="chevron-down" />
                      <b-icon icon="chevron-up" />
                    </div>
                  </a>
                </div>
                <b-collapse id="year-collapse">
                  <b-list-group flush>
                    <b-list-group-item href="#">2020</b-list-group-item>
                    <b-list-group-item href="#">2019</b-list-group-item>
                    <b-list-group-item href="#">2018</b-list-group-item>
                  </b-list-group>
                </b-collapse>
              </b-list-group-item>
              <b-list-group-item href="#">Este mes</b-list-group-item>
            </b-list-group>
          </b-collapse>

          <div class="filterCategoryTitle">
            <a
              v-b-toggle
              href="#autor-collapse"
              @click.prevent
              class="d-flex justify-content-between w-100"
            >
              Autor
              <div>
                <b-icon icon="chevron-down" />
                <b-icon icon="chevron-up" />
              </div>
            </a>
          </div>
          <b-collapse id="autor-collapse">
            <filter-list :filterItems="autorList" @input="selAuthor($event)" />
          </b-collapse>
        </div>
        <div
          class="mt-5 p-3"
          style="background: #c8c3c240; border-radius: 1rem;"
        >
          <div
            style="font-size: 16px; font-weight: bold; margin-bottom: .1rem;"
          >
            Contacto de prensa
          </div>
          <div
            style="font-family: 'Nunito Sans', sans-serif; line-height: 1.1; margin-bottom: .5rem; font-size:14px;"
          >
            Victoria Ronsano
            <a href="mailto:vronsano@parmenia.com.ar" style="color: black;"
              >vronsano@parmenia.com.ar</a
            >
          </div>
        </div>
      </b-col>
      <b-col cols="12">
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import FilterList from "@/components/FilterList.vue";
import axios from "axios";

export default {
  name: "Noticias",
  components: {
    FilterList
  },
  data: function() {
    return {
      breadcrumb: [
        {
          text: "Inicio",
          to: { name: "Home" }
        },
        {
          text: "Sala de prensa",
          active: true
        }
      ],
      filters: {
        author: [],
        category: [],
        price:{},
        filter: ''
      },
      autorList: [],
      categories: []

    };
  },
  mounted() {
    
    this.getCategories();
    this.getAuthors();
  },
  methods: {
    async getCategories() {
      console.log(this.$store.state.user.siteData);

      this.categories = await axios
        .post(
          this.$store.state.user.siteData.location + "categories/categories",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = {};
          evtResponse.data.records.forEach(element => {
            if (element.parent && element.parent !== null) {
              result[element.parent].childs.push(element);
            } else {
              result[element.id] = element;
              result[element.id].childs = [];
            }
          });
          return result;
        });
    },
    async getAuthors() {
      console.log(this.$store.state.user.siteData);

      this.autorList = await axios
        .post(
          this.$store.state.user.siteData.location + "authors/authors",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = [];
          evtResponse.data.records.forEach(element => {
            if (element.lastname){
              result.push({ label: element.name + ' ' + element.lastname, id: element.id });
            }else{
              result.push({ label: element.name , id: element.id });
            }
            
          });
          return result;
        });
    },
    selCategory(category) {
      if (!this.filters.category.includes(category)){
        this.filters.category.push(category);
        this.$emit("input", this.filters);
      }
    },
    removeCategory(category){
      this.filters.category.splice( this.filters.category.indexOf(category) ,1);
      this.$emit("input", this.filters);
    },
    selAuthor(author) {
      if (!this.filters.author.includes(author)){
        this.filters.author.push(author);
        this.$emit("input", this.filters);
      }
    },
    removeAuthor(author){
      this.filters.author.splice( this.filters.author.indexOf(author) ,1);
      this.$emit("input", this.filters);
    },
    removeSearch(){
      this.filters.filter = "";
      this.$emit("input", this.filters);
    },
    categoryName(category){
        if (this.categories[category]){
          return this.categories[category].name;
        }else{
          let name = '';
          for(const categoryItems in this.categories){
            if (this.categories[categoryItems].childs.length !== 0){              
              this.categories[categoryItems].childs.forEach((element) => {                
                if (parseInt(element.id) === parseInt(category)){
                  name = element.name;
                }
              });
            }
          }
          return name;
        }
    },
    authorName(author){
      let name = '';
      this.autorList.forEach((element) => {
        if (element.id === author){
          name = element.label;
        }
      });
      return name;
    },
  }
};
</script>
